<!-- Spinner -->

<!-- Content -->
@if (question && trainingResult && trainingResult.answer !== undefined) {
  <!-- Header -->
  <medsurf-quiz-question-header [index]="((trainingSharedFacade.quizActive$ | async) ? undefined : question.customEnumeration) || (((trainingSharedFacade.selectedQuestionIndex$(question.id) | async) || index) + 1).toString()"
    [checkedAndCorrect]="trainingResult.showFeedback && isCorrect()"
    [questionType]="question.type">
  </medsurf-quiz-question-header>
  <!-- Question Form -->
  <form name="form"
    class="mdsf-quiz-form">
    <!-- Question Text -->
    <medsurf-text [text]="question.content"></medsurf-text>
    <!-- Choices -->
    <div class="choice"
      [class.choice-error]="trainingResult.showFeedback && trainingResult.answer !== '' && question.solution !== trainingResult.answer"
      [class.choice-correct]="trainingResult.showFeedback && trainingResult.answer !== ''&& question.solution === trainingResult.answer"
      [class.no-hover]="trainingResult.showFeedback">
      <div ngbRadioGroup
        class="btn-group-toggle m-1"
        data-toggle="buttons">
        <label ngbButtonLabel
          class="radio-custom mr-2 "
          [class.radio-custom-black]="trainingResult.answer === 1 || (question.solution === 1 && (menuSharedFacade.showPrintForAuthor$ | async))"
          [class.radio-custom-error]="trainingResult.showFeedback && trainingResult.answer === 1 && question.solution !== trainingResult.answer">
          <input ngbButton
            type="radio"
            name="choices{{question.order}}"
            [value]="1"
            (click)="onClick(1)"
            [checked]="trainingResult.answer === 1">
          <i class="fa fa-check mr-2"></i> <b>{{ 'yes' | translate}}</b>
          @if (trainingResult.showFeedback && trainingResult.answer === 1 && question.solution !== trainingResult.answer) {
            <i class="fal fa-times cross"></i>
          }
        </label>
        <label ngbButtonLabel
          class="radio-custom"
          [class.radio-custom-black]="trainingResult.answer === 0 || (question.solution === 0 && (menuSharedFacade.showPrintForAuthor$ | async))"
          [class.radio-custom-error]="trainingResult.showFeedback && trainingResult.answer === 0 && question.solution !== trainingResult.answer">
          <input ngbButton
            type="radio"
            name="choices{{question.order}}"
            [value]="0"
            (click)="onClick(0)"
            [checked]="trainingResult.answer === 0">
          <i class="fa fa-times mr-2"></i> <b>{{ 'no' | translate}}</b>
          @if (trainingResult.showFeedback && trainingResult.answer === 0 && question.solution !== trainingResult.answer) {
            <i class="fal fa-times cross"></i>
          }
        </label>
      </div>
    </div>
    <!-- Explanation -->
    @if (question.explanation && (trainingResult.showExplanation || (menuSharedFacade.showPrintForAuthor$ | async))) {
      <div class="form-control-explanation"
        >
        <strong>{{ 'explanation' | translate }}:</strong>
        <medsurf-text [text]="question.explanation"></medsurf-text>
      </div>
    }
    <!-- Footer -->
    @if ((menuSharedFacade.showPrint$ | async) === false && question.solution !== null) {
      <medsurf-quiz-question-footer #footer
        class="mt-2"
        [question]="question"
        [trainingResult]="trainingResult"
        [isCorrect]="isCorrect"
        [passRequired]="passRequired"
        [(showRequired)]="showRequired"
        [ngStyle]="{'order': 100}">
      </medsurf-quiz-question-footer>
    }
  </form>
} @else {
  <div class="d-flex justify-content-center m-2">
    <div class="spinner-border"></div>
  </div>
}
